<template>
  <div>
    <!-- page wrapper start -->
    <div class="pg-wrapper default-page bg-white-imp">
      <app-header>
        <div class="title-bar" slot="header-foot">
          <button  class="button is-flex nav-back">
          </button>
          <h1 class="title has-text-black">Verify User</h1>
        </div>
      </app-header>
      <main class="content-wrapper">
        <section class="section section-content">
          <div class="container">
            <div class="columns justify-content-center">
              <div class="column is-8-tablet">
                <div class="verify-token" v-if="!success">
                  <loading v-if="showLoading"></loading>
                  <p :class="'text-center ' + (showLoading ? '': 'loaded')" v-text="msg"></p>
                </div>
                <div v-if="success">
                   <p class="text-center" v-text="msg"></p>
                  <button @click="goShopPage()" class="button mt20 is-large is-primary is-full-width">Start Browsing</button>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <app-footer></app-footer>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import LocationApis from '@/Components/Controllers/LocationApis';
import OrderHistoryApis from '@/Components/Controllers/OrderHistoryApis';
import CartApis from '@/Components/Controllers/CartApis';
import UserApis from '@/Components/Controllers/UserApis';
import LoginApis from '@/Components/Controllers/LoginApis';
import Helpers from '@/Components/Helpers/Helpers';
import VboutApis from '@/Components/Controllers/VboutApis';

export default {
  name: 'LoginWithToken',
  data() {
    return {
      msg: 'Please Wait. We are verifying your details....',
      location: {},
      showLoading: true,
      verificationStatus: false,
      success: false,
    };
  },

  computed: {
    ...mapGetters({
      vg_userId: "getLoggedInUserId",   
      vg_selectedStore: "location/selected",
      vg_businessLoyality: "businessprofile/businessLoyality",
      vg_businessProfile: "businessprofile/detail", 
    })
  },
  watch: {
    'vg_userId'(val){
      if(this.verificationStatus == false){
        this.$router.push({ 
          name: 'StoreLanding', 
          params: { 
            business_slug: this.$route.params.business_slug, 
            store_slug: this.$route.params.store_slug, 
          }, 
          query: { ...Helpers.refineQuery(['token','user_token'],this.$route.query) }
        })
      }
    },
  },

  mounted() {
    let user_token = this.$route.query.user_token;
    if(user_token){
      this.loginWithAuthToken(user_token); 
    } else {
      this.$router.push({ 
        name: 'StoreProfile', 
        params: { 
          business_slug: this.$route.params.business_slug,
          store_slug: this.$route.params.store_slug  
        },
        query: Helpers.refineQuery(['token','user_token'],this.$route.query),
      });
    }
  },

  methods: {
 
    /**
     * Login via token, clear if  user logged in
     */
    async loginWithAuthToken(user_token) {
      const self = this;
      let res = await LoginApis.loginWithToken({ token: user_token });
      if(res.status != 200){
        this.msg = res.response.data.msg ? res.response.data.msg : 'Sorry, we cannot find your detail.'; // res.response.data.msg;
        this.showLoading = false;
        this.verificationStatus = false;
      } else {
        this.verificationStatus = true;
        this.msg = 'Token Verified. Logging in...';
        // Remove existing data
        await this.$store.dispatch("REMOVE_APP_DATA");
        // Set new user values
        await this.$store.dispatch("SET_USER_TOKEN", res.data.payload.token);
        await this.$store.dispatch("SET_USER_DETAILS", res.data.payload);
        this.$store.dispatch('SET_VISITOR_DETAILS', {
          ageVerify: true,
          dob: '',
          province: '',
          remember: false,
        });   

        // If user has email_verification_status = true tag it 
        if(res.data.payload.email_verification_status){
          VboutApis.addUserTag({
            email: res.data.payload.email,
            tagname: 'verified',
          }, this.vg_selectedStore.id);
        }
        // casl_opt_in as marketing notification
        if(res.data.payload.marketing_notification){
          VboutApis.addUserTag({
            email: res.data.payload.email,
            tagname: 'casl_opt_in',
          }, this.vg_selectedStore.id);
        }

        // Fetch user loyalty points
        if( this.vg_businessLoyality.id && this.vg_businessLoyality.is_active){
          this.va_setUserLoyalityObj({
            user_id: this.vg_userId, 
            business_id: this.vg_businessProfile.id,
          });
        }

        // Fetch order history
        // let orderHistory = await OrderHistoryApis.fetch(1);
        // if(orderHistory.status == 200) {
        //   this.va_setAllOrders(orderHistory.data.payload);
        // }
        // Fetch user fav products
        UserApis.fetchFavProducts();
        // Fetch user fav locations
        UserApis.fetchFavLocations();
   
        if(!_.isEmpty(this.vg_selectedStore) && this.vg_selectedStore.id != ''){
          await CartApis.locationCart(this.vg_selectedStore.id, Helpers.getLocationCartFullUrl(this));
        }
        this.msg = 'Successfully logged in.';
        this.success = true;
      }
    },

    goShopPage() {
      this.$router.push({ 
        name: 'StoreLanding', 
        params: { 
          business_slug: this.$route.params.business_slug, 
          store_slug: this.$route.params.store_slug, 
        }, 
        query: Helpers.refineQuery(['token','user_token'],this.$route.query),
      })
    },

    ...mapActions({
      // va_loginWithToken: "auth/loginWithToken",
      va_setAllOrders: "orderhistory/setAllOrders",
      va_setUserLoyalityObj: "userloyalitysubscription/setUserLoyalityObj",
    })

  },
};
</script>

<style scoped>
.verify-token {
    position: relative;
}
.verify-token p {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 50px;
}
p.text-center.loaded {
  bottom: 0;
  position: relative;
  margin: 80px 0;
}
</style>